import type { ReactElement } from 'react';

export type ProductFilter = 'all' | 'crude' | 'gas' | 'inactive';

export interface ProductTileCounts {
  all: number;
  crude: number;
  gas: number;
  inactive: number;
}

interface ProductTilesProps {
  counts: ProductTileCounts;
  filter: ProductFilter;
  onFilter: (filter: ProductFilter) => void;
}

function tileClass(active: boolean): string {
  return `tile ${active ? 'tile-active' : ''}`;
}

export function ProductTiles({ counts, filter, onFilter }: ProductTilesProps): ReactElement {
  return (
    <section className="tiles-grid" data-testid="product-tiles">
      <article className={tileClass(filter === 'all')} onClick={() => onFilter('all')}>
        <h3>All</h3>
        <p>{counts.all}</p>
      </article>
      <article className={tileClass(filter === 'crude')} onClick={() => onFilter('crude')}>
        <h3>Crude</h3>
        <p>{counts.crude}</p>
      </article>
      <article className={tileClass(filter === 'gas')} onClick={() => onFilter('gas')}>
        <h3>Gas</h3>
        <p>{counts.gas}</p>
      </article>
      <article className={tileClass(filter === 'inactive')} onClick={() => onFilter('inactive')}>
        <h3>Inactive</h3>
        <p>{counts.inactive}</p>
      </article>
    </section>
  );
}
